function ChooseBox(e, className) {
  const allElement = Array.prototype.slice.call(document.getElementsByClassName(className))
  allElement.map((element) => {
    element.classList.remove('active')
  })
  e.currentTarget.classList.add('active')
}
export default ChooseBox
